import * as React from "react";
import type { SVGProps } from "react";
const SvgPencil = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.497 3.737a3.83 3.83 0 0 0-2.704 1.056l-1 1-9.5 9.5A1 1 0 0 0 3 16v4a1 1 0 0 0 1 1h4a1 1 0 0 0 .707-.293l10.5-10.5.023-.024a3.83 3.83 0 0 0-2.733-6.446ZM17.5 9.086l.28-.28a1.83 1.83 0 0 0-2.586-2.586l-.28.28L17.5 9.086Zm-4-1.172 2.586 2.586-8.5 8.5H5v-2.586l8.5-8.5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPencil;
